import React from "react";
import { NoDataAvailableDiv } from "../components/NoDataAvailableDiv";
import { getFormElementType } from "utilities/freefieldUtils";

interface Props {
  categories: server.dto.FreeFieldCategorySmall[]
  onFreeFieldAdded: (ff: server.dto.FreeFieldDefinitionSmall) => void
  excludeIds: number[]
}

const AddFreefieldModal = (props: Props) => {
  const excludeIds = new Set(props.excludeIds);

  // Filter dataset
  const categories = props.categories.map((cat) => {
    const definitions = cat.definitions.filter(def => !excludeIds.has(def.freeFieldDefinitionId));

    if (definitions.length === 0) {
      return null;
    }

    return {
      title: cat.title,
      definitions
    };
  }).filter(a => a !== null);

  if (categories.length === 0) {
    return (<NoDataAvailableDiv />);
  }

  return <div className="scrollbox-auto">
    {categories.map((cat, idx) => <div className="margin-bottom-large" key={idx}>
      <div className="gray-250 padding">{cat.title}</div>
      <div className="list striped margin-bottom">
        {cat.definitions.map(def => <div className="flex padding hoverable" key={def.freeFieldDefinitionId} onClick={() => { props.onFreeFieldAdded(def); }}>
          <div className="grow1">
            <div>{def.title}</div>
            <div className="text-sublabel">{getFormElementType(def.type).text}</div>
          </div>
        </div>)}
      </div>
    </div>)}
  </div>;
};

export default AddFreefieldModal;